<template lang="html">
 <div class="border-right" id="sidebar-wrapper">
    <div class="header-sidebar" slot="header">
        <img :src="basepath+'/unodc_logo.png'" alt="" width="200" />
    </div>
    <div class="list-group list-group-flush mb-3">
      
        <router-link to="/dashboard/program-officer/todoList" class="list-group-item list-group-item-action">
            <i class="material-icons">home</i> Dashboard
        </router-link>
        <router-link to="/dashboard/program-officer/conductedTraining" class="list-group-item list-group-item-action">
           <i class="material-icons">assignment_turned_in</i> Un-Assigned Training <span class="badge badge-danger pl-2 pr-2" style="font-size:14px">{{Counter}}</span>
        </router-link>
        <div>
            <div slot="header" class="list-group-item list-group-item-action" id="mybutton"><i class="material-icons pr-1">brightness_low</i><b>Training Management</b>
            </div>

            <ul>
                 <router-link to="/dashboard/program-officer/QuestionBank" class="list-group-item list-group-item-action">
            <i class="material-icons">remove</i> Create Question Bank
          </router-link>

      
        <router-link to="/dashboard/program-officer/questionbankarchives" class="list-group-item list-group-item-action">
            <i class="material-icons">remove</i> Question Bank
          </router-link>

          <router-link to="/dashboard/program-officer/KnowledgeBaseArchive" class="list-group-item list-group-item-action">
            <i class="material-icons">remove</i> Knowledge Base
          </router-link>
         </ul>
        </div>
         <div style="margin-bottom:130px">
            <router-link to="/dashboard/programOfficer/reportsOfficerAll"  slot="header" class="list-group-item list-group-item-action" id="mybutton">
            <i class="material-icons pr-1">chrome_reader_mode</i
            ><b> Reports</b>
             </router-link>
          </div>
         <!-- <div> -->
            <!-- <div slot="header" class="list-group-item list-group-item-action" id="mybutton"><i class="material-icons pr-1">chrome_reader_mode</i><b>Reports</b>
            </div>
            <ul>
            <router-link to="/dashboard/programOfficer/ReportsOfficerGraphs" class="list-group-item list-group-item-action">
                   <i class="material-icons">remove</i> Statistics & Graphs
                    
                  </router-link>
                  <router-link to="/dashboard/programOfficer/ReportsFilterOfficer" class="list-group-item list-group-item-action">
                   <i class="material-icons">remove</i> Trainings
                    
                  </router-link>
                  <router-link to="/dashboard/Advisor/thematicAreaAdvisor" class="list-group-item list-group-item-action">
                   <i class="material-icons">remove</i> Thematic Area
                   
                  </router-link>
                    <router-link to="/dashboard/Advisor/subprogramListAdvisor" class="list-group-item list-group-item-action">
                   <i class="material-icons">remove</i>Sub Program Wise
                    
                  </router-link>
                    <router-link to="/dashboard/Advisor/projectListAdvisor" class="list-group-item list-group-item-action">
                   <i class="material-icons">remove</i> Project Wise
                    
                  </router-link>
            </ul> -->
           
              <!-- <div slot="header" class="list-group-item list-group-item-action" id="mybutton"><i class="material-icons pr-1">chrome_reader_mode</i><b>Report Forms</b>
            </div>
              <ul>
                  <router-link to="/dashboard/programOfficer/traineePreassessment" class="list-group-item list-group-item-action">
                  <i class="material-icons">remove</i> Preassessment Report
                  </router-link>

                  <router-link to="/dashboard/programOfficer/traineePostassessment" class="list-group-item list-group-item-action">
                  <i class="material-icons">remove</i> Postassessment Report
                  </router-link>

                  <router-link to="/dashboard/programOfficer/attendanceSheet" class="list-group-item list-group-item-action">
                  <i class="material-icons">remove</i> Attendance Sheet
                  </router-link>

                <router-link to="/dashboard/programOfficer/feedbackTrainer" class="list-group-item list-group-item-action">
                <i class="material-icons">remove</i> Trainer Feedback Report
                </router-link>

                <router-link to="/dashboard/programOfficer/feedbackTrainee" class="list-group-item list-group-item-action">
                 <i class="material-icons">remove</i> Trainee Feedback Report
                  
                </router-link>
                <router-link to="/dashboard/programOfficer/regFormTrainee" class="list-group-item list-group-item-action">
                
                <i class="material-icons">remove</i> Trainer Feedback Report
                  
                </router-link>
                <router-link to="/dashboard/programOfficer/agendaReport" class="list-group-item list-group-item-action">
                 <i class="material-icons">remove</i> Trainer Feedback Report
                  
                </router-link>
                <router-link to="/dashboard/programOfficer/registerationReport" class="list-group-item list-group-item-action">
                 <i class="material-icons">remove</i> Registration Form Report
                  
                </router-link>
                <router-link to="/dashboard/programOfficer/agendaFormReport" class="list-group-item list-group-item-action">
                  <i class="material-icons">remove</i> Agenda Form Report
                  
                </router-link>
              </ul> -->
        <!-- </div> -->
    </div>
    </div>
    <!-- Sidebar -->
    <!-- <div class="border-right" id="sidebar-wrapper">
      <div class="header-sidebar" slot="header">
          <img :src="basepath+'/unodc_logo.png'" alt="" width="200" />
      </div>

      <div class="list-group list-group-flush">
          <router-link to="/dashboard/program-officer/todoList" class="list-group-item list-group-item-action">
            <i class="material-icons">home</i> Home
          </router-link>

           <router-link to="/dashboard/program-officer/QuestionBank" class="list-group-item list-group-item-action">
            <i class="material-icons">create_new_folder</i> Create Question Bank
          </router-link>

      
        <router-link to="/dashboard/program-officer/questionbankarchives" class="list-group-item list-group-item-action">
            <i class="material-icons">live_help</i> Question Bank
          </router-link>

          <router-link to="/dashboard/program-officer/KnowledgeBaseArchive" class="list-group-item list-group-item-action">
            <i class="material-icons">file_copy</i> Knowledge Base
          </router-link>

          <vs-collapse> 
            
            <vs-collapse-item icon-arrow="arrow_drop_down">
              <div slot="header" class="list-group-item list-group-item-action"> <i class="material-icons">report</i> Reports
              </div>
              <ul>
                 <router-link to="/dashboard/programOfficer/ReportsOfficerGraphs" class="list-group-item list-group-item-action">
                    Statistics & Graphs
                  </router-link>
                  <router-link to="/dashboard/programOfficer/ReportsFilterOfficer" class="list-group-item list-group-item-action">
                    Trainings
                  </router-link>
                  <router-link to="/dashboard/Advisor/thematicAreaAdvisor" class="list-group-item list-group-item-action">
                    Thematic Area
                  </router-link>
                    <router-link to="/dashboard/Advisor/subprogramListAdvisor" class="list-group-item list-group-item-action">
                    Sub Program Wise
                  </router-link>
                    <router-link to="/dashboard/Advisor/projectListAdvisor" class="list-group-item list-group-item-action">
                    Project Wise
                  </router-link>
              </ul>
               </vs-collapse-item>
          </vs-collapse>
<vs-collapse>
            <vs-collapse-item icon-arrow="arrow_drop_down">
              <div slot="header" class="list-group-item list-group-item-action"> <i class="material-icons">subtitles</i> Report Forms
              </div>
                <ul>
                  <router-link to="/dashboard/programOfficer/traineePreassessment" class="list-group-item list-group-item-action">
                  Preassessment Report
                  </router-link>
                  <router-link to="/dashboard/programOfficer/traineePostassessment" class="list-group-item list-group-item-action">
                    Postassessment Report
                  </router-link>
                  <router-link to="/dashboard/programOfficer/attendanceSheet" class="list-group-item list-group-item-action">
                  Attendance Sheet
                </router-link>
                <router-link to="/dashboard/programOfficer/feedbackTrainer" class="list-group-item list-group-item-action">
                  Trainer Feedback Report
                </router-link>
                <router-link to="/dashboard/programOfficer/feedbackTrainee" class="list-group-item list-group-item-action">
                  Trainee Feedback Report
                </router-link>
                <router-link to="/dashboard/programOfficer/regFormTrainee" class="list-group-item list-group-item-action">
                  Trainer Feedback Report
                </router-link>
                <router-link to="/dashboard/programOfficer/agendaReport" class="list-group-item list-group-item-action">
                  Trainer Feedback Report
                </router-link>
                <router-link to="/dashboard/programOfficer/registerationReport" class="list-group-item list-group-item-action">
                  Registration Form Report
                </router-link>
                <router-link to="/dashboard/programOfficer/agendaFormReport" class="list-group-item list-group-item-action">
                  Agenda Form Report
                </router-link>
                </ul>
             </vs-collapse-item>
             </vs-collapse>
          
       </div>
    </div> -->
    </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    active: true,
    basepath: localStorage.getItem("BASE_PATH"),
    Counter : 0,
  }),
  created() {
    // bus.$on("sidebarStatus", data => {
    //   this.active = data;
    // });
  },
   mounted() {
    // Set the initial number of items
    this.unassignedTrainingsCount();
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    unassignedTrainingsCount: function unassignedTrainingsCount(){
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/program_officer/unassigned/count-training/" +
          JSON.parse(localStorage.getItem("currentUser")).id
      ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if(response.data && response.data.unsignedTrainingCount){
          this.Counter = response.data.unsignedTrainingCount;
        }
        
      });
    },
  }
};
</script>
<style>
/* .list-group-item:hover {
  padding-left: 30px;
  transition: 0.5s ease;
} */
.con-vs-dropdown--menu {
  width: 16% !important;
}
.no-cascading > h3 {
  display: none !important;
}
.vs-dropdown--group-label {
  font-size: 20px !important;
}
.con-vs-dropdown--menu.vs-dropdown-menu.rightx.notHeight {
  left: 220px !important;
  top: 0px !important;
}
.con-dropdown--group-con-ul {
  border-left: transparent !important;
}
.vs-dropdown--item .vs-dropdown--item-link {
  padding: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.vs-dropdown--group.marginIcon {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
</style>

<style scoped>
/*!
 * Start Bootstrap - Simple Sidebar (https://startbootstrap.com/template-overviews/simple-sidebar)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-simple-sidebar/blob/master/LICENSE)
 */
.vs-collapse {
  padding: 0px !important;
}
.vs-collapse-item--header {
  padding: 0px !important;
}
@media (min-width: 768px) {
  .sidebarx {
    display: block !important;
  }
  .vs-sidebar--background {
    z-index: 0 !important;
    background: transparent !important;
  }
}

@media (max-width: 768px) {
  .vs-sidebar--background {
    background: rgba(0, 0, 0, 0.2) !important;
  }
}

body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */
</style>